// extracted by mini-css-extract-plugin
export default {"OfferPrecision":"offerPrecision_OfferPrecision__y8Jpy","head_offer":"offerPrecision_head_offer__NqUPx","offer_left_col":"offerPrecision_offer_left_col__jf9uA"};